import { useEffect } from 'react';
import { isBrowser } from '../../utils';

/**
 * При первом рендере компонента ScrollToTop страница проскролится к началу.
 * Это может пригодиться, когда мы переходим с длинной страницы, предварительно проскролив страницу до конца,
 * на другую длинную страницу. Если не добавить ScrollToTop, то скролл не сбросится и вторая страница
 * отрендерится со смещенным скроллом.
 */

export function ScrollToTop() {
  useEffect(() => {
    if (isBrowser) {
      window.scrollTo(0, 0);
    }
  }, []);

  return null;
}
